// postMessage protocol antara parent (Studio) dan child (sandbox iframe).
// Lihat Doc 09 §10.3.

export const PROTOCOL_VERSION = 1

// Parent → Child
export const MSG_INIT = 'init'
export const MSG_STOP = 'stop'
export const MSG_DESTROY = 'destroy'

// Child → Parent
export const MSG_SANDBOX_LOADED = 'sandbox_loaded'
export const MSG_READY = 'ready'
export const MSG_CODE_EXECUTED = 'code_executed'
export const MSG_ASSET_LOADED = 'asset_loaded'
export const MSG_BOOT_ERROR = 'boot_error'
export const MSG_ERROR = 'error'
export const MSG_PERF = 'perf'
export const MSG_STOPPED = 'stopped'
export const MSG_DESTROYED = 'destroyed'

const PARENT_TO_CHILD = new Set([MSG_INIT, MSG_STOP, MSG_DESTROY])
const CHILD_TO_PARENT = new Set([
  MSG_SANDBOX_LOADED,
  MSG_READY,
  MSG_CODE_EXECUTED,
  MSG_ASSET_LOADED,
  MSG_BOOT_ERROR,
  MSG_ERROR,
  MSG_PERF,
  MSG_STOPPED,
  MSG_DESTROYED,
])

export function isParentToChild(type) {
  return PARENT_TO_CHILD.has(type)
}

export function isChildToParent(type) {
  return CHILD_TO_PARENT.has(type)
}

export function makeMessage(type, payload = {}) {
  return { protocol: PROTOCOL_VERSION, type, payload }
}

export function parseMessage(data) {
  if (!data || typeof data !== 'object') return null
  if (data.protocol !== PROTOCOL_VERSION) return null
  if (!isParentToChild(data.type) && !isChildToParent(data.type)) return null
  return { type: data.type, payload: data.payload ?? {} }
}
